<template>
  <BaseModal
    :close-button-visible="false"
    overlay-class="other_modals please_wait_game no_close"
  >
    <div class="loader">
      <div class="wait_btn">
        <i class="fas fa-chevron-right"></i>
      </div>

      <div class="text">
        <AnimatedDotText text="modal_loader_game_please_wait" />

        <p>{{ $_translations.value.modal_loader_game_get_ready }}</p>
      </div>
    </div>

    <p class="loader_disc">
      {{ $_translations.value.modal_loader_game_description_pt1 }} <br>
      {{ $_translations.value.modal_loader_game_description_pt2 }}
    </p>
  </BaseModal>
</template>

<script setup>
import BaseModal from '@/components/modal/BaseModal.vue';
import AnimatedDotText from '@/components/text/AnimatedDotText.vue';
</script>
